export default __webpack_public_path__ + "static/media/distance_between_grey.76287c9c.svg";